<span class="ssn-masked" [attr.aria-label]="ariaLabel()">
  @if (showIcon()) {
    <umss-icon name="phosphorIdentificationCard" [size]="iconSize()" aria-hidden="true" />
  }
  @if (hasValue()) {
    <span class="ssn-masked__value" aria-hidden="true">{{ masked() }}</span>
  } @else {
    <span class="ssn-masked__fallback" aria-hidden="true">{{ fallback() }}</span>
  }
</span>
